import api from 'src/api'
import { AvailableUnits } from 'src/helpers/units/AvailableUnits'
import { emitter } from './emitter'

export class UnitsService {
  static changeUnits(units: AvailableUnits) {
    if (units && units !== this.getUnits()) {
      localStorage.setItem('units', units)

      return api.units.changeUserUnits(units).then(() => {
        emitter.emit('unitSystemChanged')
      })
    }
  }

  static getUnits(): AvailableUnits {
    return (localStorage.getItem('units') as AvailableUnits) || 'metric'
  }
}
